import imageManifest from '../generated/imageManifest.json';

// Build a flat list of image objects for the given photo categories.
// Shared by the Gallery page and the per-apartment pages so they stay in sync
// with the generated manifest (client/src/generated/imageManifest.json).
export const buildImages = (categories = []) => {
    const images = [];

    categories.forEach((category) => {
        (imageManifest[category] || []).forEach((image) => {
            images.push({
                ...image,
                id: `${category}-${image.filename}`,
                category,
                src: image.src,
                alt: image.alt,
            });
        });
    });

    return images;
};

// Return the first available image across an ordered list of categories,
// e.g. for an apartment hero or card thumbnail. Returns null when none exist.
export const getFirstImage = (categories = []) => {
    for (const category of categories) {
        const list = imageManifest[category] || [];
        if (list.length > 0) {
            return list[0];
        }
    }
    return null;
};
